namespace RioERP.Enquiry {
    @Serenity.Decorators.registerClass()
    export class EnquiryGrid1 extends Serenity.EntityGrid<EnquiryRow, any> {
        protected getColumnsKey() { return EnquiryColumns.columnsKey; }
        protected getDialogType() { return EnquiryDialog; }
        protected getIdProperty() { return EnquiryRow.idProperty; }
        protected getInsertPermission() { return EnquiryRow.insertPermission; }
        protected getLocalTextPrefix() { return EnquiryRow.localTextPrefix; }
        protected getService() { return EnquiryService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

        }


        protected getQuickFilters() {

            var filters = super.getQuickFilters();



            return [];

        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 4);

            return buttons;
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {

            return this.CustomerId != null;
        }


        private _CustomerId: number;

        get CustomerId() {
            return this._CustomerId;
        }
        set CustomerId(value: number) {
            if (this._CustomerId != value) {
                this._CustomerId = value;
                this.setEquality(EnquiryRow.Fields.CustomerId, value);
                this.refresh();
            }
        }
    }
}